export const assessmentTemplate = [
  {
    _id: "0002",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-07T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "dementiaSeverityRatingScale",
      omniTypeVersion: 1,
      title: "Dementia Severity Rating Scale",
      purpose: "Cognitive Functionality",
      description:
        "The Dementia Severity Rating Scale (DSRS) is an informant-based, multiple-choice questionnaire that assesses severity from the mildest to the most severe stages in the major functional and cognitive domains affected in Alzheimer disease (AD).",
      duration: "About 15 minutes",
      directions:
        "For each question, please select the number that most closely applies to the participant. This is a general form, so no one description may be exactly right -- please select the answer that seems to apply most of the time and be sure to answer all questions.",
      attribution: "Dr. Christopher M Clark, Alzheimer’s Disease Core Center",
      validated: false,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "DSRS1",
          numberText: "1",
          text: "Do you live with the participant?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the most appropriate answer.",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              displayType: "button",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              displayType: "button",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS2",
          numberText: "2",
          text: "How much contact do you have with the participant?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the most appropriate answer.",
          answerOptions: [
            {
              value: "less than 1 day per week",
              text: "Less than 1 day per week",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1 day per week",
              text: "1 day/week",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2 days per week",
              text: "2 days/week",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3-4 days per week",
              text: "3-4 days/week",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5 or more days per week",
              text: "5 or more days per week",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS3",
          numberText: "3",
          text: "Relationship to participant",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the most appropriate answer.",
          answerOptions: [
            {
              value: "self",
              text: "Self",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "spouse",
              text: "Spouse",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "sibling",
              text: "Sibling",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "child",
              text: "Child",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "family friend",
              text: "Family Friend",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Other",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS4",
          numberText: "4",
          text: "Memory",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal memory",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Occasionally forgets things that they were told recently. ",
              subText: "Does not cause many problems.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Mild consistent forgetfulness.",
              subText: "Remembers recent events but often forgets parts.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Moderate memory loss. Worse for recent events.",
              subText:
                "May not remember something you just told them. Causes problems with everyday activities.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Substantial memory loss.",
              subText:
                "Quickly forgets recent or newly-learned things. Can only remember things that they have known for a long time.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "Does not remember basic facts",
              subText:
                "like the day of the week, when last meal was eaten or what the next meal will be.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "Does not remember even the most basic things.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS5",
          numberText: "5",
          text: "Speech and Language",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal ability to talk and to understand others.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Sometimes cannot find a word, but able to carry on conversations.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Often forgets words.",
              subText:
                "May use the wrong word in its place. Some trouble expressing thoughts and giving answers.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Usually answers questions using sentences but rarely starts a conversation.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Answers questions, but responses are often hard to understand or don't make sense.",
              subText: "Usually able to follow simple instructions.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "Speech often does not makes sense.",
              subText: "Can not answer questions or follow instructions.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "6",
              text: "Does not respond most of the time",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS6",
          numberText: "6",
          text: "Recognition of Family Members",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal",
              subText: "Recognizes people and generally knows who they are.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Usually recognizes grandchildren, cousins or relatives who are <b>not</b> seen frequently",
              subText: "but may not recall how they are related.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Usually does not recognize family members who are not seen frequently.",
              subText:
                "Is often confused about how family members such as grandchildren, nieces, or nephews are related to them.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Sometimes does not recognize family members or others who they see frequently.",
              subText:
                "May not recognize their children, brothers, or sisters who are not seen on a regular basis.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Frequently does not recognize <u>spouse</u> or <u>caregiver</u>.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "No recognition or awareness of the presense of others.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS7",
          numberText: "7",
          text: "Orientation to Time",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal awareness of time of day and day of week.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Some confusion about what time it is or what day of the week,",
              subText: "but not severe enough to interfere with everyday activities.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Frequently confused about time of day.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Almost always confused about time of day.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Seems completely unaware of time.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS8",
          numberText: "8",
          text: "Orientation to Place",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal awareness of where they are even in new places.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Sometimes disoriented in new places.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Frequently disoriented in new places.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Usually disoriented, even in familiar places.",
              subText: "May forget that they are already at home.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Almost always confused about place.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS9",
          numberText: "9",
          text: "Ability to Make Decisions",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal",
              subText: "As able to make decisions as before.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Only some difficulty making decisions that arise in day-to-day life.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Moderate difficulty.",
              subText: "Gets confused when things get complicated or plans change.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Rarely makes any important decisions.",
              subText: "Gets confused easily.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Not able to understand what is happening most of the time.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS10",
          numberText: "10",
          text: "Social and Community Activity",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal",
              subText: "Acts the same with people as before.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Only mild problems that are not really important,",
              subText: "but clearly acts differently from previous years.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Can still take part in community activities without help.",
              subText: "May appear normal to people who don't know them.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Often has trouble dealing with people outside the home without help from caregiver.",
              subText:
                "Usually can participate in quiet home activities with friends. The problem is clear to anyone who sees them.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "No longer takes part in any real way in activities at home involving other people.",
              subText: "Can only deal with the primary caregiver.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "5",
              text: "Little or no response even to primary caregiver.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS11",
          numberText: "11",
          text: "Home Activities and Responsibilities",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal.",
              subText: "No decline in abilty to do things around the house.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Some problems with home activities.",
              subText:
                "May have more trouble with money management (paying bills) and fixing things. Can still go to a store, cook or clean.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Makes mistkes with easy tasks like going to a store, cooking or cleaning.",
              subText:
                "Losing interest in the newspaper, TV or radio. Often can't follow a long conversation on a single topic.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Not able to shop, cook or clean without a lot of help.",
              subText: "Does not understand the newspaper or the TV. Cannot follow a conversation.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "No longer does any home-based activities.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS12",
          numberText: "12",
          text: "Personal Care - Cleanliness",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal.",
              subText: "Takes care of self as well as they used to do.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Not as neat as they used to be.",
              subText:
                "Sometimes forgets to wash, shave, comb hair, or may dress in wrong type of clothes.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Requires help with dressing, washing and personal grooming.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Totally dependent on help for personal care.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS13",
          numberText: "13",
          text: "Eating",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal",
              subText: "Does not need help in eating food that is served to them.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "May need help cutting food or have trouble with some foods, but basically able to eat by themselves.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Generally able to feed themselves but may require some help.",
              subText: "May lose interest during the meal.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Needs to be fed.",
              subText: "May have trouble swallowing.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS14",
          numberText: "14",
          text: "Control of Urination and Bowels",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal",
              subText:
                "Does not have problems controlling urination or bowels except for physical problems.",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Rarely fails to control urination",
              subText: "(generally less that one accident per month)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Occasional failure to control urination",
              subText: "(about once a week or less)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Frequently fails to control urination.",
              subText: "(more than once a week)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "4",
              text: "Generally fails to control urination and frequently can not control bowels.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "DSRS15",
          numberText: "15",
          text: "Ability to get from place to place",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Normal, able to get around on their own.",
              subText: "(May have physical problems that require a cane or walker).",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "1",
              text: "Sometimes gets confused when driving or taking public transportation, especially in new places.",
              subText: "Able to walk places alone.",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "2",
              text: "Cannot drive or take public transportation alone, even in familiar places.",
              subText:
                "Can walk alone outside for short distances. Might get lost if walking too far from home.",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "3",
              text: "Cannot be left outside alone.",
              subText: "Can get around the house without getting lost or confused.",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "4",
              text: "Gets confused and needs help finding their way around the house.",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "5",
              text: "Almost always in a bed or chair.",
              subText: "May be able to walk a few steps with help, but lacks a sense of direction.",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "6",
              text: "Always in bed.",
              subText: "Unable to sit or stand.",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "dementiaSeverityRatingScale",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 54,
        formula: null,
        questions: [1, 2, 3, 4],
      },
    ],
  },
];
